"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoryblokComponentProvider = StoryblokComponentProvider;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var ComponentRegistryContext = (0, _react.createContext)(null);

function StoryblokComponentProvider(props) {
  var registry = props.registry,
      children = props.children;
  return _react["default"].createElement(ComponentRegistryContext.Provider, {
    value: registry
  }, children);
}

var _default = ComponentRegistryContext;
exports["default"] = _default;